import { Modal, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";

export default function EligibilityDataModal({
  showEligibilityDataModal,
  setShowEligibilityDataModal,
  eligibilityData,
  patientPolicies,
  selectedPolicy,
}) {
  const [selectedPolicyID, setSelectedPolicyID] = useState(undefined);
  const [eligibilityTableData, setEligibilityTableData] = useState([]);
  useEffect(
    function () {
      if (patientPolicies && patientPolicies.length > 0) {
        setSelectedPolicyID(patientPolicies[0].id);
      }
    },
    [patientPolicies],
  );

  useEffect(
    function () {
      if (eligibilityData && eligibilityData.policy_coverage.length > 0) {
        const matchDataPolicy = eligibilityData.policy_coverage.find((policy) => policy.policy_id === selectedPolicyID);
        if (matchDataPolicy && matchDataPolicy.procedures.length > 0) setEligibilityTableData(matchDataPolicy.procedures);
      }
    },
    [eligibilityData],
  );

  const eligibilityDataColumns = [
    {
      title: "Procedure Code",
      dataIndex: "procedure_code",
      key: "procedure_code",
    },
    {
      title: "Procedure Name",
      dataIndex: "procedure_name",
      key: "procedure_name",
      render: (text) => (text !== "" ? text : "-"),
    },
    {
      title: "Eligible Today",
      dataIndex: "eligible_today",
      key: "eligible_today",
    },
    {
      title: "Last Verified",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  console.log(eligibilityTableData.find((eligibility) => eligibility.id === selectedPolicy));

  return (
    <Modal
      open={showEligibilityDataModal}
      onCancel={() => setShowEligibilityDataModal(false)}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <Typography.Title level={4} style={{ marginBottom: 0 }}>
            Eligibility Data
          </Typography.Title>

          {/* <Select
            options={patientPolicies.map((policy) => ({
              value: policy.id,
              label: (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}>
                  <div>{policy.insurance_name_display}</div>
                  <div>{policy.insurance_type_display}</div>
                </div>
              ),
            }))}
            onChange={(value) => setSelectedPolicyID(value)}
            value={selectedPolicyID}
            placeholder="Select Policy"
            style={{ width: 200 }}
            className="treatment-filter-input"
          /> */}
        </div>
      }
      width="75%"
      footer={null}
    >
      <Table columns={eligibilityDataColumns} dataSource={eligibilityTableData} pagination={{ position: ["bottomCenter"] }} />
    </Modal>
  );
}
